import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => (
  <footer className="bg-[#1B3F33] text-white py-16 lg:py-20" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
        <div className="lg:col-span-1">
          <h3 className="font-heading text-2xl font-semibold mb-4">
            Emplozera<span className="text-[#8C6330]"> Studio</span>
          </h3>
          <p className="text-sm text-white/60 leading-relaxed">
            The premier digital marketing and accounting partner for forward-thinking
            doctors and clinics worldwide.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-[#8C6330] mb-4">Services</h4>
          <ul className="space-y-2">
            {['Google Business', 'AI-Powered Website', 'SEO Services', 'Social Media'].map((s) => (
              <li key={s}>
                <a href="#services" className="text-sm text-white/60 hover:text-white transition-colors" data-testid={`footer-link-${s.toLowerCase().replace(/\s|&/g, '-')}`}>
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-[#8C6330] mb-4">Quick Links</h4>
          <ul className="space-y-2">
            {[
              { label: 'Pricing', href: '#pricing' },
              { label: 'Case Studies', href: '#case-studies' },
              { label: 'Testimonials', href: '#testimonials' },
              { label: 'FAQ', href: '#faq' },
              { label: 'Book Consultation', href: '#consultation' },
            ].map((link) => (
              <li key={link.label}>
                <a href={link.href} className="text-sm text-white/60 hover:text-white transition-colors" data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, '-')}`}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-[#8C6330] mb-4">Contact</h4>
          <ul className="space-y-3">
            <li>
              <a href="https://wa.me/14372327525" className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors" data-testid="footer-phone">
                <Phone size={14} />
                +1 437-232-7525 (WhatsApp)
              </a>
            </li>
            <li>
              <a href="mailto:emplozerastudio@gmail.com" className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors" data-testid="footer-email">
                <Mail size={14} />
                emplozerastudio@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-2 text-sm text-white/60">
              <MapPin size={14} className="mt-0.5 flex-shrink-0" />
              Global
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-white/40" data-testid="footer-copyright">
          &copy; {new Date().getFullYear()} Emplozera Studio. All rights reserved.
        </p>
        <div className="flex gap-6">
          <a href="#" className="text-xs text-white/40 hover:text-white transition-colors">Privacy Policy</a>
          <a href="#" className="text-xs text-white/40 hover:text-white transition-colors">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
